export const ds_ButtonGroupLayoutBlock_Entry = `
    fragment ds_ButtonGroupLayoutBlock_Entry on ds_ButtonGroupLayoutBlock_Entry {
        id
        canonicalUid
        buttonGroup_ColorTheme
        buttonGroup_ColorPalette
        buttonGroup_Alignment
        buttonGroup_ContentAlignment
        buttonGroup_Padding
        buttonGroup_Buttons {
            text
            target
            title
            url
            ariaLabel
            ... on buttonGroup_Buttons_Custom_LinkType {
                buttonStyle
            }
            ... on buttonGroup_Buttons_Entry_LinkType {
                buttonStyle
            }
            ... on buttonGroup_Buttons_Url_LinkType {
                buttonStyle
            }
            ... on buttonGroup_Buttons_Phone_LinkType {
                buttonStyle
            }
            ... on buttonGroup_Buttons_Email_LinkType {
                buttonStyle
            }
        }
    }
`
